import aria from './aria.json' with { type: 'json' };
import badges from './badges.json' with { type: 'json' };
import buttons from './buttons.json' with { type: 'json' };
import components from './components';
import errors from './errors.json' with { type: 'json' };
import features from './features';
import labels from './labels.json' with { type: 'json' };
import links from './links.json' with { type: 'json' };
import notifications from './notifications.json' with { type: 'json' };
import pages from './pages';
import placeholders from './placeholders.json' with { type: 'json' };
import tables from './tables.json' with { type: 'json' };
import titles from './titles.json' with { type: 'json' };
export default {
  aria,
  badges,
  buttons,
  components,
  errors,
  labels,
  links,
  notifications,
  pages,
  placeholders,
  features,
  tables,
  titles,
};
